import {all} from 'redux-saga/effects'

import { searchVenuesWithProductsSagaWatcher } from './search_venues_with_products.saga'
import { clearSearchResultsSagaWatcher } from './clear_search_results.saga'


export default function* searchresultsSaga() {
    yield all([
        searchVenuesWithProductsSagaWatcher(),
        clearSearchResultsSagaWatcher()
    ])
}